import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export interface MapComponentProps {
  containerSize: {
    width: number;
    height: number;
  };
  horses: racehorse360.IHorse[];
  mapRootRef: React.RefObject<SVGGElement>;
  clipPathRef: React.RefObject<SVGRectElement>;
  svgContainerRef: React.RefObject<HTMLDivElement>;
  handleGroupClick?: (e: React.MouseEvent) => void;
  isPreview?: boolean;
}

const haveSameBarnAssignments = (
  prevHorses: racehorse360.IHorse[],
  nextHorses: racehorse360.IHorse[]
) => {
  if (prevHorses === nextHorses) return true;
  if (prevHorses.length !== nextHorses.length) return false;

  return prevHorses.every(
    (horse, index) =>
      horse.id === nextHorses[index].id &&
      horse.barn?.name === nextHorses[index].barn?.name
  );
};

export const mapPropsAreEqual = (
  prev: MapComponentProps,
  next: MapComponentProps
): boolean =>
  prev.mapRootRef === next.mapRootRef &&
  prev.svgContainerRef === next.svgContainerRef &&
  prev.clipPathRef === next.clipPathRef &&
  prev.handleGroupClick === next.handleGroupClick &&
  prev.isPreview === next.isPreview &&
  prev.containerSize.width === next.containerSize.width &&
  prev.containerSize.height === next.containerSize.height &&
  haveSameBarnAssignments(prev.horses, next.horses);
